




























import AddToHomeScreenHandler from '@/components/AddToHomeScreenHandler.vue'
import ListItem from '@/components/list/ListItem.vue'
import Translation from '@/mixins/Translation'
import Assets from '@/mixins/Assets'
import {Drawer} from 'element-ui'
import {Component, Mixins, Prop, Watch} from 'vue-property-decorator'
import {Item} from './MenuItem.type'
import MenuList from './MenuList.vue'
import SettingPage from '@/pages/Setting.vue'
import {namespace} from 'vuex-class'

const userAgent = namespace('userAgent')
const userAction = namespace('userAction')

@Component({
  components: {
    AddToHomeScreenHandler,
    ListItem,
    MenuList,
    SettingPage,
    [Drawer.name]: Drawer,
  },
})
export default class MenuLayout extends Mixins(Translation, Assets) {
  static menuList({list, current, ts, cert}: any = {}) {
    function itemMap(item) {
      const {notice: _notice, noticeColor: _noticeColor, list} = item
      const notice = typeof _notice === 'function' ? _notice(cert) : _notice
      const noticeColor = typeof _noticeColor === 'function' ? _noticeColor(cert) : _noticeColor
      return {
        ...item,
        disabled: Boolean(list),
        titleWeight: item.to === current ? 'bold' : 'normal',
        titleColor: item.to === current ? 'gray-900' : 'gray-700',
        title: ts(item.title),
        notice: notice && ts(notice),
        noticeColor,
        list: list ? list.map((i) => {
          return {
            ...itemMap(i),
            titleSize: 'subtitle1',
            titleColor: 'gray-700'
            }
          }) : null
      }
    }
    return list.map((item) => {return itemMap(item)})
  }

  @Prop({default: false}) value: boolean
  @Prop({default: 'terms', type: String}) translation: string
  @Prop({default: null}) cert: string
  @Prop() current: string
  @Prop({default: true}) toAndClose: boolean

  @userAgent.State('isKakaoBrowser') isKakaoBrowser: boolean
  @userAgent.Getter('availableAddToHomeScreen') availableAddToHomeScreen: boolean
  @userAction.Getter('isAddedHomeScreen') isAddedHomeScreen: boolean

  open: boolean = false
  menuClass: any = {
    'has-header': true,
    'has-footer': false,
  }

  menu: Item[] = [
    {title: 'home', to: 'home', menuName: 'home'},
    {title: 'taxrefund', to: 'taxrefund', menuName: 'taxrefund'},
    {title: 'paytax', to: 'taxes', menuName: 'tax'},
    // {title: 'hidden-subsidy', to: 'subsidy', menuName: 'subsidy'},
    // {title: 'invoice', menuName: 'invoice',
    //   list: [
    //     {title: 'to-issue', to: 'issue'},
    //     {title: 'to-lookup-transfer', to: 'received-invoices'},
    //   ]
    // },
    {title: 'setting', to: 'setting', menuName: 'setting'},
  ]

  get myMenu() {
    const {current, ts, cert} = this
    return MenuLayout.menuList({ts, current, list: this.menu, cert})
  }

  get visibleHomeScreenHandler(): boolean {
    return !this.isAddedHomeScreen && (this.isKakaoBrowser || this.availableAddToHomeScreen)
  }

  @Watch('value', {immediate: true})
  __open(value) {
    this.open = value
  }

  onTo(name: string) {
    if(this.toAndClose) {
      this.onChange(false)
    }
    if(this.current === name) {
      this.open = false
    }
    this.$emit('to', name)
  }

  onChange(value: boolean) {
    this.open = value
    this.$emit('input', value)
  }

  onChangeMenuClass(obj) {
    this.menuClass = obj
  }
}
